import { FleekError } from './FleekError';

type EnsRecord = {
  name: string;
};

type EnsNameInvalidErrorOptions = {
  ensRecord: EnsRecord;
};

export class EnsNameInvalidError extends FleekError<EnsNameInvalidErrorOptions> {
  public name = 'EnsNameInvalidError';

  toString = () => {
    return `ENS record name "${this.data.ensRecord.name}" is invalid.`;
  };
}
